import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as me from '../../../feature'
import type { Feature } from '../feature'

/** Requests the selected zone's apps unless they are loaded or loading. */
export const startGetZoneApps = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.selectors.zoneContext.asObservable.pipe(
      rxjs.distinctUntilChanged(isDeepEqual),
      rxjs.filter(TypeChecker.isNotNullish.raw),
      rxjs.switchMap(context =>
        meFeature.zoneApps.selectors
          .getShouldRequest(context.zoneId)
          .asObservable.pipe(
            rxjs.take(1),
            rxjs.map(shouldRequest =>
              shouldRequest
                ? meFeature.zoneApps.actions.get
                    .from('ZoneApps.Context.Changed')
                    .create(context)
                : store.effects.SKIP,
            ),
          ),
      ),
    ),
)
